import { render, staticRenderFns } from "./IndicatorsCard.vue?vue&type=template&id=cdf89828"
import script from "./IndicatorsCard.vue?vue&type=script&lang=js"
export * from "./IndicatorsCard.vue?vue&type=script&lang=js"
import style0 from "./IndicatorsCard.vue?vue&type=style&index=0&id=cdf89828&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports